/**
 * Cloudflare R2 buckets — request validators.
 */
import { z } from 'zod';
import { R2_BUCKET_PURPOSES } from '../types/r2-buckets.js';
export const R2BucketPurposeSchema = z.enum(R2_BUCKET_PURPOSES);
// R2 bucket names: 3-63 chars, lowercase alphanumeric + hyphens, must start
// and end with alphanumeric. Cloudflare follows the S3 naming rules.
const BUCKET_NAME_REGEX = /^[a-z0-9][a-z0-9-]{1,61}[a-z0-9]$/;
export const R2BucketCreateInputSchema = z.object({
    name: z
        .string()
        .min(3)
        .max(63)
        .regex(BUCKET_NAME_REGEX, 'Bucket name must be lowercase alphanumeric + hyphens (3-63 chars)'),
    label: z.string().min(1).max(80),
    purpose: R2BucketPurposeSchema,
    publicBaseUrl: z.string().url().max(500).nullable().optional(),
    isDefault: z.boolean().optional(),
});
export const R2BucketPatchInputSchema = R2BucketCreateInputSchema.partial().refine((d) => Object.keys(d).length > 0, { message: 'At least one field must be provided' });
export const R2BucketIdParamSchema = z.object({
    id: z.string().uuid(),
});
//# sourceMappingURL=r2-buckets.schema.js.map